module.exports = __webpack_public_path__ + "img/icon-users.cecdaf37.svg";